import { KybStepCode } from '~/api/kyb/types'

export const CURRENT_STEP = KybStepCode.REVIEW
